import { TableColumn } from "../../../../contract/list_v2/Table";
import Link from "../../../../contract/list_v2/Table/components/Link";
import Money from "../../../../contract/list_v2/Table/components/Money";
import StatusPill from "../../../../contract/list_v2/Table/components/StatusPill";
import { ECONTRACT_STATUS } from "../../../../../enums";
import { ILockerShipmentSettlementContract } from "../../../../../setup/api/services/lockerShipment/models";
import { formatAmount } from "../../../../../setup/util/wallet";

/** Shared by the match preview and the settlement result. */
export const contractColumns: TableColumn<ILockerShipmentSettlementContract>[] =
  [
    {
      key: "shortId",
      label: "رقم المعاملة",
      // Opens the contract in a new tab, so the modal (and its result) stays open.
      render: (value, row) => (
        <span dir="ltr">
          <Link text={`#${value}`} contractId={row.id} />
        </span>
      ),
    },
    {
      key: "shipmentRequestId",
      label: "رقم التتبع",
      render: (value) => <span dir="ltr">{value || "-"}</span>,
    },
    {
      key: "itemPrice",
      label: "قيمة المعاملة",
      render: (value) =>
        value == null ? "-" : <Money amount={formatAmount(value)} />,
    },
    {
      key: "shipmentFee",
      label: "رسوم الشحن",
      render: (value) =>
        value == null ? "-" : <Money amount={formatAmount(value)} />,
    },
    {
      key: "status",
      label: "الحالة",
      render: (value) =>
        value ? <StatusPill status={value as ECONTRACT_STATUS} /> : "-",
    },
    {
      key: "createdAt",
      label: "تاريخ الإنشاء",
      render: (value) =>
        value
          ? new Date(value).toLocaleDateString("ar-EG", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })
          : "-",
    },
  ];

export const contractColumnVisibility = Object.fromEntries(
  contractColumns.map((col) => [col.key, true])
);
